import io from "socket.io-client";

export const SOCKET_URL =
  process.env.VUE_APP_SOCKET_URL ||
  (process.env.NODE_ENV === "development"
    ? "http://localhost:6001"
    : "https://api.shamspharmacy.com:6001");

export const NOTIFY_EVENT = "notification";

export function createNotificationSocket({ userId, token, onNotification, onJoinError }) {
  if (!userId) {
    return null;
  }

  const socket = io(SOCKET_URL, {
    transports: ["websocket", "polling"],
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 10000,
    timeout: 10000,
  });

  const joinRoom = () => {
    socket.emit("join", { userId, token });
  };

  socket.on("connect", joinRoom);
  socket.on("reconnect", joinRoom);

  socket.on("joined", () => {
    if (process.env.NODE_ENV === "development") {
      console.debug("[socket] joined notification room");
    }
  });

  socket.on(NOTIFY_EVENT, (payload) => {
    if (payload && typeof onNotification === "function") {
      onNotification(payload);
    }
  });

  if (typeof onJoinError === "function") {
    socket.on("join_error", onJoinError);
  } else if (process.env.NODE_ENV === "development") {
    socket.on("join_error", (err) => {
      console.warn("[socket] join failed:", err?.error || err);
    });
  }

  return socket;
}

export function destroyNotificationSocket(socket) {
  if (!socket) {
    return;
  }

  socket.off("connect");
  socket.off("reconnect");
  socket.off(NOTIFY_EVENT);
  socket.off("join_error");
  socket.disconnect();
}
